<h2 mat-dialog-title>{{ 'ASSOCIATIONS.CAMPAIGNS.ADD_ASSOCIATION' | translate }}</h2>
<mat-dialog-content>
  <p class="subtitle">{{ 'ASSOCIATIONS.CAMPAIGNS.START' | translate }}</p>
  <div content>
    <form [formGroup]="formGroup">
      <glxy-form-field class="campaigns-button-group">
        <mat-radio-group formControlName="selectFormControl" ngDefaultControl>
          <mat-radio-button [checked]="true" [value]="'now'">
            {{ 'ASSOCIATIONS.CAMPAIGNS.START_CAMPAIGN.NOW' | translate }}
            <extended class="hint">
              {{ 'ASSOCIATIONS.CAMPAIGNS.START_NOW' | translate }} {{ nowDate | date: 'long' }}
            </extended></mat-radio-button
          >
          <mat-radio-button [value]="'later'">
            {{ 'ASSOCIATIONS.CAMPAIGNS.START_CAMPAIGN.LATER' | translate }}
            <extended class="hint">
              {{ 'ASSOCIATIONS.CAMPAIGNS.START_LATER' | translate }}
            </extended></mat-radio-button
          >
        </mat-radio-group>
        <glxy-form-field *ngIf="formGroup.controls.selectFormControl.value === 'later'" class="datepicker">
          <input type="datetime-local" matInput formControlName="dateFormControl" />
          <mat-datepicker></mat-datepicker>
        </glxy-form-field>
      </glxy-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <ng-container>
    <button mat-stroked-button class="campaign-back-button" color="primary" (click)="back()">
      {{ 'ACTIONS.BACK' | translate }}
    </button>
    <button mat-flat-button class="campaign-next-button" color="primary" (click)="sendCampaign()">
      <glxy-button-loading-indicator>
        {{ 'ASSOCIATIONS.CAMPAIGNS.ADD_TO_CAMPAIGN' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </ng-container>
</mat-dialog-actions>
